import { collection, doc, onSnapshot, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { db } from './firebase';

export type RallyChoice = 'in' | 'dontCare';

const COLLECTION = 'rallyChoices';

export function rallyChoiceDocId(eventId: string, requestId: string, attendeeId: string): string {
  return `${eventId}_${requestId}_${attendeeId}`;
}

export async function setRallyChoice(
  eventId: string,
  requestId: string,
  attendeeId: string,
  choice: RallyChoice,
): Promise<void> {
  await setDoc(doc(db, COLLECTION, rallyChoiceDocId(eventId, requestId, attendeeId)), {
    eventId,
    requestId,
    attendeeId,
    choice,
    updatedAt: serverTimestamp(),
  });
}

function isRallyChoice(value: unknown): value is RallyChoice {
  return value === 'in' || value === 'dontCare';
}

export function subscribeToMyRallyChoices(
  eventId: string,
  attendeeId: string,
  onChange: (choices: Map<string, RallyChoice>) => void,
): () => void {
  const choicesQuery = query(
    collection(db, COLLECTION),
    where('eventId', '==', eventId),
    where('attendeeId', '==', attendeeId),
  );
  return onSnapshot(
    choicesQuery,
    snap => {
      const choices = new Map<string, RallyChoice>();
      for (const choiceDoc of snap.docs) {
        const data = choiceDoc.data();
        if (typeof data.requestId === 'string' && isRallyChoice(data.choice)) choices.set(data.requestId, data.choice);
      }
      onChange(choices);
    },
    error => {
      console.error('Failed to load rally choices:', error);
      onChange(new Map());
    },
  );
}
